// Valuation asset handling
import $ from "jquery";

/**
 * Recalculate %, £ remaining and the accepted (capped) input values for a row.
 *
 * @param itemRow the claim row they've edited
 * @param pounds pound value from the input, null if they changed %
 * @param percent percent value from the input, null if they changed £
 * @param assets assets total after modifying the selection but before refreshing, normally null
 */
const getRecalculatedAmounts = function (itemRow, pounds, percent, assets) {
  let cost = fromCurrency(itemRow.data("cost"));
  let previousAmountClaimed = fromCurrency(
    itemRow.data("previousamountclaimed")
  );

  let totalFromAssets = parseFloat(assets);
  if (!isFinite(totalFromAssets)) {
    totalFromAssets = $(itemRow)
      .find(".js-project-assets-allocation")
      .map(function (_index, e) {
        return fromCurrency($(e).data("amount"));
      })
      .get()
      .reduce(function (a, b) {
        return a + b;
      }, 0);
  }

  // start with the naive input values and moderate them
  let poundsAccepted = pounds;
  let pctAccepted = percent;

  // compute % or £ from the other
  pctAccepted = parseFloat(pctAccepted);
  poundsAccepted = parseFloat(poundsAccepted);

  if (isFinite(poundsAccepted)) {
    pctAccepted = (100 * poundsAccepted) / cost;
  } else if (isFinite(pctAccepted)) {
    poundsAccepted = cost * (pctAccepted / 100);
  } else {
    poundsAccepted = 0;
    pctAccepted = 0;
  }

  // cap: can't be more than remaining, can't be more than cost, *CAN* be negative if it's a discount
  let sign = cost < 0 ? -1 : +1;
  let remaining = cost - previousAmountClaimed - totalFromAssets;
  poundsAccepted = sign * Math.min(Math.abs(cost), Math.abs(remaining), Math.abs(poundsAccepted));
  pctAccepted = (100 * poundsAccepted) / cost;
  let remainingAccepted = Math.max(0, remaining - poundsAccepted);

  let blob = {
    // old, for debugging
    inputPounds: pounds,
    inputPercent: percent,
    previousAmountClaimed: previousAmountClaimed,
    remainingCost: remaining,
    totalFromAssets: totalFromAssets,

    // invariant
    cost: cost,

    // new, gets displayed
    poundsAccepted: poundsAccepted,
    pctAccepted: pctAccepted,
    remainingAmount: remainingAccepted,
  };

  // console.log(JSON.stringify(blob, null, 2));

  return blob;
};

/** Apply the outcome of recalculating figures. */
const updateFigures = function (blob, row) {
  row.find(".js-valuation-item-amount").val(blob.poundsAccepted.toFixed(2));
  row.find(".js-valuation-item-percentage").val(blob.pctAccepted.toFixed(2));

  row.find(".js-amount-remaining").text(toCurrency(blob.remainingAmount));
};

/** 1234.56 to £1,234.56 */
const toCurrency = function (decimalPounds) {
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
  }).format(decimalPounds);
};

/** Convert 12.34, '12.34' or '£1,234.00' to a float. */
const fromCurrency = function (poundsOrFloat) {
  if (!poundsOrFloat) {
    return 0;
  }
  let f = parseFloat(poundsOrFloat.toString().replace(/[^0-9\.\-]/g, ""));
  return isFinite(f) ? f : 0;
};

// User-edited inputs
$(function () {
  let percentageInput = $(".js-valuation-item-percentage");
  let amountInput = $(".js-valuation-item-amount");
  let deductions = $("input.js-valuation-deduction");

  amountInput.on("change", function () {
    let amount = $(this).val();
    let itemRow = $(this).parents(".js-valuation-item");

    if (isNaN(amount)) {
      console.error("A number was not entered for £.");
      clearFigures(itemRow);
      return;
    }

    let item = getRecalculatedAmounts(itemRow, amount, null, null);
    updateFigures(item, itemRow);
  });

  percentageInput.on("change", function () {
    let percentage = $(this).val();
    let itemRow = $(this).parents(".js-valuation-item");

    if (isNaN(percentage)) {
      console.error("A number was not entered for %.");
      clearFigures(itemRow);
      return;
    }

    let item = getRecalculatedAmounts(itemRow, null, percentage, null);
    updateFigures(item, itemRow);
  });

  deductions.on("change", function () {
    let itemRow = $(this).parents(".js-valuation-item");
    let selected = $(this).prop("checked");
    let rawPounds = $(this).data("pounds");
    let amount = parseFloat(rawPounds);

    if (isNaN(amount)) {
      console.error("A number was not entered for £.", rawPounds, amount);
      clearFigures(itemRow);
      return;
    }

    console.log("Applying deduction of %s, checked=%s", amount, selected)

    let item = getRecalculatedAmounts(
      itemRow,
      selected ? amount : 0,
      null,
      null
    );
    updateFigures(item, itemRow);
  });

  const clearFigures = function (itemRow) {
    let amountInput = itemRow.find(".js-valuation-item-amount");
    let percentageInput = itemRow.find(".js-valuation-item-percentage");

    percentageInput.val("0.00");
    amountInput.val("0.00");
  };
});

// Assets
$(function () {
  const toggleContainer = function (boqid) {
    let container = $("#project-assets-container");
    container.data("boqid", boqid);
    container.toggleClass("hidden");
    container.toggleClass("flex");
  };

  const updateTotalValueOfSelectedAssets = function (row) {
    let totalAssets = 0;

    $("input.js-project-assets-selector").each(function (_index, element) {
      let checkbox = $(element);
      let isChecked = checkbox.prop("checked");
      let cashValue = fromCurrency(checkbox.data("value"));

      if (isChecked && isFinite(cashValue)) {
        // add to total
        totalAssets += parseFloat(cashValue);
      }
    });

    // todo make the total grow bright red if its above the target
    $(".js-project-assets-total").text(toCurrency(totalAssets));

    let remaining = row.find(".js-amount-remaining");
    let cost = fromCurrency(remaining.data("cost"));
    let claimed = fromCurrency(remaining.data("claimed"));
    let userEntered = parseFloat(
      row.find("input.js-valuation-item-amount").val()
    );

    let newRemaining = parseFloat(cost - claimed - userEntered - totalAssets);
    if (isFinite(newRemaining)) {
      // update the text
      let s = toCurrency(newRemaining);
      remaining.text(s);

      let container = $("#project-assets-container");
      container.find(".js-picker-amount-remaining").text(s);

      // sweep the inputs disabling those > the remaining
      container
        .find("input.js-project-assets-selector")
        .each(function (_index, element) {
          let checkbox = $(element);
          let isChecked = checkbox.prop("checked");
          let cashValue = fromCurrency(checkbox.data("value"));
          checkbox.prop("disabled", !isChecked && cashValue > newRemaining);
        });
    }
  };

  const bindModal = function () {
    $(".js-project-assets-container-close")
      .off("click tap")
      .on("click tap", function (e) {
        e.preventDefault();
        toggleContainer(null);
        return false;
      });

    $("input.js-project-assets-selector")
      .off("change")
      .on("change", function (event) {
        let rowId = $(event.target).data("boqid");
        let row = $(`#${rowId}`);
        updateTotalValueOfSelectedAssets(row);
      });

    $("button.js-project-assets-container-apply")
      .off("click tap")
      .on("click tap", function (e) {
        e.preventDefault();
        let trigger = $(e.target);
        let valuationId = trigger.data("valuationid");
        let claimId = trigger.data("boqid");
        let selected = $("input.js-project-assets-selector:checked")
          .map(function () {
            return $(this).attr("id");
          })
          .get();
        let updatedAssetsTotal = $("input.js-project-assets-selector:checked")
          .map(function () {
            return fromCurrency($(this).data("value"));
          })
          .get()
          .reduce(function (a, b) {
            return a + b;
          }, 0);

        let body = {
          valuationId: valuationId,
          boqClaimId: claimId,
          lineItemIds: selected,
        };

        fetch("/admin/updateallocations", {
          method: "POST",
          headers: {
            "content-type": "application/json",
          },
          body: JSON.stringify(body),
        })
          .then(() => {
            // update %/£ inputs ...
            let row = $(`#${claimId}`);
            let pounds = row.find(".js-valuation-item-amount").val();
            let blob = getRecalculatedAmounts(
              row,
              fromCurrency(pounds),
              null,
              updatedAssetsTotal // subtract £X from assets that the punter won't have to pay
            );
            updateFigures(blob, row);

            // ... and post back the form, jumping back to this row
            let form = $("form.js-edit-valuation");
            let action = `${form.attr("action")}#${claimId}`;
            form.attr("action", action);
            form[0].submit();
          })
          .catch(function (err) {
            console.warn(err);
            toggleContainer(null);
          });
      });
  };

  /** Get the elligible assets list when hitting the allocate materials button. */
  const refreshMaterials = function (mouseEvent) {
    mouseEvent.preventDefault();
    let button = $(mouseEvent.target);
    let boqId = button.data("boqid");
    let boqRow = button.parents(".js-valuation-item");
    let cost = boqRow.data("cost");
    let previousClaimString = boqRow.data("previousamountclaimed");
    let currentClaimString = boqRow.find(".js-valuation-item-amount").val();
    let valuationId = boqRow.parents(".js-valuation-id").data("valuationid");

    let container = $("#project-assets-container");
    let placeholder = container.find(".js-project-assets-list-placeholder");
    let destination = container.find(".js-project-assets-list");
    let errorMessage = container.find(".js-project-assets-list-error");

    placeholder.removeClass("hidden");
    errorMessage.addClass("hidden");
    destination.addClass("hidden");
    destination.empty();

    // show the modal
    toggleContainer(boqId);

    if (
      valuationId &&
      isFinite(cost) &&
      isFinite(previousClaimString) &&
      isFinite(currentClaimString)
    ) {
      let remaining =
        parseFloat(cost) -
        parseFloat(previousClaimString) -
        parseFloat(currentClaimString);
      let remainingString = remaining.toFixed(2);
      fetch(
        `/admin/elligibleassets?valuationId=${valuationId}&claimId=${boqId}&value=${remainingString}`
      )
        .then((resp) => resp.text())
        .then((rendered) => {
          let newContent = $(rendered);
          newContent.appendTo(destination);

          // check selected
          let selected = boqRow
            .find(".js-project-assets-allocation")
            .map(function () {
              return $(this).data("lineitemid");
            })
            .get();
          newContent.find("input.js-project-assets-selector").each(function () {
            let c = $(this);
            let id = c.attr("id");
            c.prop("checked", selected.includes(id));
          });

          // bind event listeners
          bindModal();
          updateTotalValueOfSelectedAssets(boqRow);

          // show the thing
          placeholder.addClass("hidden");
          destination.removeClass("hidden");
        })
        .catch((err) => {
          bindModal();
          placeholder.addClass("hidden");
          destination.addClass("hidden");
          errorMessage.removeClass("hidden");
          console.warn(err);
        });
    } else {
      // do nothing -- not enough data
    }
    return false;
  };

  $(".js-assets-reveal")
    .off("click tap")
    .on("click tap", function (e) {
      return refreshMaterials(e);
    });
});
